export default __webpack_public_path__ + "static/media/790651372273664050.ae7ba437.png";